'use strict';

import {
    highlightMenuButtonDependsOnMode, isMapOpened, setCSSVar,
    userPrevent,
} from '../../../functions';
import {isDesktop, isMobile, projectMode, settingsData, UIRoot} from '../../../settings';
import {CardTypes, ViewMode} from "../../../common";
import gsap from 'gsap';
import {openSearchHandler} from "../search/search";
import { getCurrentLangDirection} from '../../components/langSwitcher/langSwitcher';
import {
    closePages,
    floorSliderVisibility,
    getActiveMenuData,
    menuHandler,
    setMenuElementsState,
    setMenuActive,
} from '../menu';
import { closePanorama, isPanoramaActive, panoramaCloseHandler } from '../../widgets/poi/poiv3';
import { checkMapPanoramaInOrbit } from '../../poi/poi';
import {UnitCardClass} from "../../cards/unitCards/UnitCardClass";
import {closeOptionsCard} from "../../cards/cardsFunctions";
import {PopUpPage} from "../../interfaces/pages/PopUp";
import { transferToBuilding } from '../../threejs/camera';
import { BmbyMode } from '../../mode/BmbyMode';
import {BaseElement} from "../../interfaces/BaseElement";

export const rightNavigationBar = () => {
    const backButtonMobileClasses = ['menu__back-btn', 'button-modes', 'button-modes--back', 'icon-back', 'background-backdrop-filter'];
    const buttonsArr = [
        {
            name: 'district',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--district', 'icon-district'],
            dataAttr: 'district',
            isVisible: false
        },
        {
            name: 'orbit',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--orbit', 'icon-orbit-project'],
            dataAttr: 'orbit',
            // isVisible: buildings_info.length > 1
            isVisible: false
        },
        {
            name: 'orbit',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--orbit', 'icon-orbit-building'],
            dataAttr: 'orbit',
            // isVisible: buildings_info.length === 1
            isVisible: false
        },
        {
            name: 'cylinder',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--cylinder', 'icon-cylinder-building'],
            dataAttr: 'cylinder',
            isVisible: false
        },
        {
            name: 'floorplan',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--splitFloor', 'icon-floorplan', 'hide'],
            dataAttr: 'floorplan',
            isVisible: false
        },
        {
            name: 'play',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--play', 'icon-play'],
            dataAttr: 'play',
            isVisible: false
        },
        {
            name: 'back',
            tagType: 'button',
            classes: isMobile ? backButtonMobileClasses : ['button-modes', 'button-modes--back', 'icon-back'],
            dataAttr: 'back',
            isVisible: true
        },
        // {
        //     name: 'filter',
        //     tagType: 'button',
        //     unitCards: ['button-filter', 'icon-search', 'non-canvas'],
        //     dataAttr: 'filter',
        //     isVisible: true
        // },
    ];

    let container = document.querySelector('.right-nav-bar');
    if (container)
        return;

    // container = createElements('div', ['right-nav-bar', 'non-canvas', 'hide'], UIRoot);
    container = new BaseElement()
        .addClass('right-nav-bar', 'non-canvas', 'hide')
        .appendTo(UIRoot);
    // const wrapper = createElements('div', ['right-nav-bar__wrapper', 'non-canvas'], container.DOMElement);
    const wrapper = new BaseElement()
        .addClass('right-nav-bar__wrapper', 'non-canvas')
        .appendTo(container.DOMElement);
    // const buttonsWrapper = createElements('div', ['buttons__wrapper', 'non-canvas'], wrapper.DOMElement);
    const buttonsWrapper = new BaseElement()
        .addClass('buttons__wrapper', 'non-canvas')
        .appendTo(wrapper.DOMElement);
    const headerCheckBox = document.querySelector('.header__burger-menu__input');
    headerCheckBox && headerCheckBox.addEventListener('change', () => {
        rightNavMenuZIndexChange(2);
    },false);

    for (const {name, tagType, classes, isVisible, dataAttr} of buttonsArr) {
        let element;

        if (isVisible) {
            switch (name) {
                case settingsData.activeViewMode: {
                    classes.push('active');
                    break;
                }
                case 'play': {
                    // element = createElements(tagType, classes, wrapper.DOMElement, 'afterbegin');
                    element = new BaseElement(tagType)
                        .addClass(...classes)
                        .appendTo(wrapper.DOMElement, 'afterbegin');
                    break;
                }
                case 'back': {
                    // element = createElements(tagType, classes, buttonsWrapper.DOMElement, 'afterbegin');
                    element = new BaseElement(tagType)
                        .addClass(...classes)
                        .appendTo(buttonsWrapper.DOMElement, 'afterbegin');

                    if (isDesktop)
                        element.addClass('prevent-hide');
                    break;
                }
                default: {
                    // element = createElements(tagType, classes, buttonsWrapper.DOMElement);
                    element = new BaseElement(tagType)
                        .addClass(...classes)
                        .appendTo(buttonsWrapper.DOMElement);
                    break;
                }
            }
            element.addAttribute('data-button', dataAttr);
        }
    }

    buttonsWrapper.event('click', buttonsWrapperHandler);
}

export function buttonsWrapperHandler ({target}) {
    if (userPrevent() || settingsData.activeViewMode === ViewMode.Cylinder && BmbyMode.active)
        return;

    if (isDesktop ) {
        floorSliderVisibility('show');
        if (settingsData.activeViewMode !== ViewMode.FloorPlan)
            setMenuElementsState('visible');

        const isAnyPopUpPageOpened = document.querySelector('.pop-up-page:not(.hidden)');
        if (isAnyPopUpPageOpened) {
            PopUpPage.hide();
            highlightMenuButtonDependsOnMode();
            projectMode.Pagination.paginate({source: 'widget-close-button'});
            if (settingsData.activeViewMode === ViewMode.Orbit)
                hideRightNavBar();
            return;
        }

        if (isMapOpened()) {
            if (settingsData.activeViewMode !== ViewMode.Orbit) {
                const mapWidgetElement = document.querySelector('.widget__container[data-menu-item="map"]');
                mapWidgetElement.classList.remove('show-page');
                highlightMenuButtonDependsOnMode();
                projectMode.Pagination.paginate({source: 'widget-close-button'});
            } else {
                menuHandler({target:{dataset:{menuItem:'3dModel'}}});
                transferToBuilding();
            }
            return;
        }
    }

    const changeModeTo = target.getAttribute('data-button');
    if (!changeModeTo || changeModeTo === settingsData.activeViewMode && changeModeTo !== ViewMode.FloorPlan)
        return;

    // if (!isMobile)
    //     UnitCardClass.cards.forEach(card => { card.html.classList.remove('unit-card--small') });

    viewModesSwitching(changeModeTo);
}

export async function viewModesSwitching(changeModeTo) {
    switch (changeModeTo) {
        case ViewMode.District: {
            districtModeHandler();
            return;
        }
        case ViewMode.Orbit: {
            if (settingsData.activeViewMode === ViewMode.FloorPlan){
                await projectMode.FloorPlan.exitFromMode();
                await projectMode.Cylinder.exitFromMode();
            } else if (settingsData.activeViewMode === ViewMode.Cylinder){
                await projectMode.Cylinder.exitFromMode();
            }
            break;
        }
        case ViewMode.Cylinder: {
            await projectMode.FloorPlan.exitFromMode();
            break;
        }
        case ViewMode.FloorPlan: {
            console.log('floor plan')
            break;
        }
        case 'back' : {
            if (settingsData.bombBlock)
                return;
            backButtonHandlerThrottling();
            break;
        }
        default: break;
    }
    if (settingsData.activeViewMode === ViewMode.Orbit)
        projectMode.Pagination.paginate({source: 'viewModesSwitching', note: 'orbit'} );
}

let timer;
function backButtonHandlerThrottling() {
    if (timer !== null)
        clearTimeout(timer);

    timer = setTimeout(function() {
        backButtonHandler();
    }, 250);
}

function districtModeHandler() {
    console.log('district is not developed');
    moveElements();
}
// async function orbitModeHandler() {
//     removeSelectionBoxesLockColor();
//     manualHide360Icons();
//
//     const timePlug = new Promise(resolve => setTimeout(()=> resolve(true),1000));
//     settingsData.animationsList.push(timePlug);
//
//     await fitModelInViewport();
//     removeCylinderFloorNumbers();
//     settingsData.customSelections = [];
//
//     settingsData.objects_to_intersection = [];
//     settingsData.instanced_floors = [];
//     settingsData.floor_obj = [];
//     // hideCylindersGrid();
//
//     // environmentToggle();
//     // backgroundShow();
//     // poiToggle(true);
//     additionalMenuToggle();
//     // toggleStreetNames(true);
//     // setTimeout(resizeCanvasWhenMenuOpened,500);
//     // resizeCanvasWhenMenuOpened();
//
//     // showAllBuildings();
//     showPointsModels('Trees small');
//     showPointsModels('Trees big');
//     setMenuActive('3dModel');
//
//     if (typeof settingsData.orbitAnimationCout === 'number'){
//         settingsData.orbitAnimationCout = 0;
//     }
//
//     if (document.body.classList.contains('filter-open')) {
//         document.querySelector('.filter-module-open-btn').click();
//     }
//
//     const buildingSwitcher = document.getElementById('building-switcher');
//
//     buildings_info.forEach(tower => {
//         // if (tower.isActive) {
//         //     changeShadowsOptions(tower, true);
//         // }
//
//         tower.searchResult = [];
//         tower.isActive = false;
//     });
//
//     // if (buildingSwitcher) buildingSwitcher.classList.add('hide');
//     if (buildingSwitcher) hideBuildingSwitcher();
//     // hideRightNavBar();
//
//     const popup = document.querySelector('.popup-info');
//     if (popup && !popup.classList.contains('hide')){
//         popup.classList.add('hide');
//     }
//
//     // setTimeout(() => {
//         // buildingsLabelsToggle();
//         // buildingsLabelUpdate();
//         // resizeCanvasWhenMenuOpened();
//
//         // hideCylindersGrid();
//         // showAllBuildings();
//         await setDefaultForeshortening();
//         // environmentToggle();
//         // toggleStreetNames(true);
//         // backgroundShow();
//         // poiToggle(true);
//
//
//         setTimeout(()=>{
//             mobileBurgerStyleToggle();
//             showAllBuildings();
//             environmentToggle();
//             hideCylindersGrid();
//             toggleStreetNames(true);
//             backgroundShow();
//             poiToggle(true);
//             // setDefaultForeshortening();
//         //     resizeCanvasWhenMenuOpened();
//         //     setDefaultForeshortening();
//         //     // hideCylindersGrid();
//         //     // showAllBuildings();
//         //     // environmentToggle();
//         //     // toggleStreetNames(true);
//         //     // backgroundShow();
//         //     // poiToggle(true);
//         },500)
//         // resizeCanvasWhenMenuOpened();
//     // }, 1000);
//
//     moveElements();
// }
// export function cylinderModeHandler(fromDestroy, buildingIndex) {
//     console.log('cylinderModeHandler');
//     return;
//     const buildingSwitcher = document.getElementById('building-switcher');
//
//     if (buildingSwitcher && buildingSwitcher.classList.contains('hide') && buildings_info.length > 1) {
//         // buildingSwitcher.classList.remove('hide');
//         // showBuildingSwitcher();
//     } else {
//         BuildingSwitch.add(document.querySelector('.main-wrap'));
//     }
//
//     if (isMobile){
//         closePoiInfoWindowCardInOrbit(true);
//     } else {
//         closePoiInfoWindowCardInOrbit(false);
//     }
//
//     // let activeTower = buildings_info.find(tower => tower.isActive);
//     let activeTower;
//
//     if (buildingIndex){
//         activeTower = buildings_info[buildingIndex];
//     } else {
//         activeTower = buildings_info.find(tower => tower.isActive);
//     }
//
//
//     if (!activeTower) {
//         buildings_info[0].isActive = true;
//         activeTower = buildings_info[0];
//     }
//
//     if (settingsData.buildingDestroyed) {
//         bombButtonInitActionHandler();
//         // setTimeout(searchResizeCanvas, 1000);
//     } else {
//         BuildingSwitch.change_building_to(buildings_info.indexOf(activeTower));
//         turnOffAllEnvironment();
//     }
//
//     if (!fromDestroy) {
//         // setTimeout(() => {
//             const searchContainer = document.querySelector('.search__container-main');
//             !searchContainer && openSearchHandler(1.5);
//         // }, 1500);
//     }
//
//
//     setMenuActive('search');
//     moveElements();
//     changeGridTexture();
// }
// function floorPlanModeHandler() {
//     if (!settingsData.lastClickedFlat) {
//         const activeTower = buildings_info.find(tower => tower.isActive);
//         const maxFloor = Math.max(...activeTower.crm_data.map(item => item.floorNum));
//         settingsData.lastClickedFlat = activeTower.all_apartments.find(apartment => apartment.userData.crm_data.floorNum === parseInt(maxFloor / 2));
//         settingsData.currentFloor = settingsData.lastClickedFlat.userData.floor;
//     }
//
//     bombButtonInitActionHandler();
//     moveElements();
// }
function backButtonHandler() {
    const exitFromWidget = backWidgetButton();
    if (exitFromWidget){
        if (settingsData.activeViewMode === ViewMode.Orbit)
            hideRightNavBar();
        return;
    }

    const card = document.querySelector(`.${CardTypes.Options}-card`);
    if (card) {
        closeOptionsCard();
        return;
    }

    const unitCard = UnitCardClass.findCard()?.html;
    unitCard && UnitCardClass.closeMultipleCards();
    switch (settingsData.activeViewMode) {
        case ViewMode.Orbit: break;
        case ViewMode.Cylinder: viewModesSwitching(ViewMode.Orbit) ; break;
        case ViewMode.FloorPlan: viewModesSwitching(ViewMode.Cylinder); break;
        default: break;
    }
}

export function backWidgetButton () {
    if (isDesktop){
        const valueArray = ['gallery','about','map'];
        const activeMenuData = getActiveMenuData();

        if (checkMapPanoramaInOrbit()){
            panoramaCloseHandler(document.querySelector('.map__panorama__orbit__show'));
            hideRightNavBar();
            return;
        }

        if (valueArray.includes(activeMenuData)){

            if(isPanoramaActive()){
                closePanorama();
                return false;
            }

           closePages();

            if (settingsData.activeViewMode === ViewMode.Orbit){
                setMenuActive('3dModel');
                // showHideButtonPlay('show');
            } else {
                setMenuActive('search');
            }
           settingsData.stopRender = false;
           if (settingsData.activeViewMode === ViewMode.Cylinder) {
               const isSearchOpened = document.querySelector('.search__container-main');
               !isSearchOpened && openSearchHandler();
            }
           return true;
        }
        return false;
    }
    return false;
}

// export function changeActiveRightMenuBtns(changeModeTo) {
//     settingsData.activeViewMode = changeModeTo;
//     const buttons = document.querySelectorAll('.button-modes');
//
//     buttons.forEach(button => {
//         const dataBtn = button.getAttribute('data-button');
//         button.classList.remove('active');
//
//         if (dataBtn === changeModeTo) {
//             button.classList.add('active');
//         }
//
//         switch (dataBtn) {
//             case ViewMode.FloorPlan: {
//                 if (changeModeTo === ViewMode.Orbit) {
//                     button.classList.add('hide');
//                     break;
//                 }
//
//                 button.classList.remove('hide');
//                 break;
//             }
//             case ViewMode.Orbit: {
//                 if (changeModeTo === ViewMode.Orbit) {
//                     button.classList.remove('icon-right');
//                     button.classList.add('icon-orbit-project');
//                     break;
//                 }
//
//                 button.classList.remove('icon-orbit-project');
//                 button.classList.add('icon-right');
//             }
//         }
//     });
// }

export function moveElements() {
    const buildingSwitch = document.getElementById('building-switcher');
    // const leftNavBar = document.querySelector('.left-nav-bar');
    const searchBtn = document.querySelector('.filter-module-open-btn');

    if (!buildingSwitch)
        return;

    if (buildingSwitch.classList.contains('hide')) {
        // if (leftNavBar && leftNavBar.classList.contains('move'))
        //     leftNavBar.classList.remove('move');
        if (searchBtn && searchBtn.classList.contains('move'))
            searchBtn.classList.remove('move');
    } else {
        // if (leftNavBar && !leftNavBar.classList.contains('move'))
        //     leftNavBar.classList.add('move');
        // setCSSVar('--left-bar-bottom-move', "calc(34px + 24px + 42px)");
        if (searchBtn && !searchBtn.classList.contains('move'))
            searchBtn.classList.add('move');
    }
}

export function rightNavMenuZIndexChange(zIndex) {
    const rightNavBar = document.querySelector('.right-nav-bar');
    if (!rightNavBar)
        return;

    setTimeout(() => {
        if (isMobile && settingsData.isLandscape) {
            const unitCard = UnitCardClass.findCard()?.html;
            const floorSlider = document.querySelector('.fs-container');

            if (!zIndex) {
                if (!unitCard || unitCard && floorSlider || !unitCard && floorSlider) {
                    zIndex = 4;
                } else if (unitCard && !floorSlider) {
                    zIndex = 2;
                }
            }
            if (parseInt(rightNavBar.style.zIndex) === zIndex)
                return;

            rightNavBar.style.zIndex = `${zIndex || 2}`;
        } else if (isMobile && document.querySelector(`.search__container-bottom.opened`)) {
            if (parseInt(rightNavBar.style.zIndex) === 4)
                rightNavBar.style.zIndex = 2;
        }
    }, 250);
}

export function showRightNavBar () {
    if (isMobile)
        return;

    let navbar = document.querySelector('.right-nav-bar');
    const langDirection = getCurrentLangDirection();
    let styleProp = langDirection === 'ltr' ? 'right' : 'left';

    if (navbar.classList.contains('showed'))
        return;

    if (isDesktop){
        styleProp = 'right';
        const backBtn = document.querySelector('.menu__back-btn');

        gsap.fromTo(navbar, {[styleProp]: -200, autoAlpha:0},{
            [styleProp]: 32,
            autoAlpha: 1,
            duration: .2,
            onStart:()=>{
                navbar.classList.remove('hide');
                navbar.classList.add('showed');
            },
            onComplete:()=>{
                navbar.style.removeProperty('left');
                navbar.style.removeProperty('right');
            }});


        gsap.fromTo(backBtn, {[styleProp]: -500, autoAlpha:0},{[styleProp]: -80, autoAlpha: 1, duration: .45,
            onStart:()=>{
                backBtn.classList.remove('prevent-hide');
            },
            onComplete:()=>{
                backBtn.style.removeProperty('opacity');
            }});

        return;
    }

    gsap.fromTo(navbar, {[styleProp]: -200, autoAlpha:0 },{[styleProp]: 32, autoAlpha: 1, duration: 1,
        onStart:()=>{
            navbar.style.removeProperty('left');
            navbar.style.removeProperty('right');
            navbar.classList.remove('hide');
        },
        onComplete:()=>{
            navbar.style.removeProperty('left');
            navbar.style.removeProperty('right');
            navbar.classList.add('showed');
        }});
}

export function toggleBackBtnInDesktopMode (action) {
    if (!isDesktop){
        return;
    }

    const rightNavBar = document.querySelector('.right-nav-bar');

    switch (action) {
        case 'hide':
            hideRightNavBar();
            break;
        case 'show':
            rightNavBar.classList.contains('hide') && showRightNavBar();
            break;
    }
}

export function hideRightNavBar () {
    if (isMobile)
        return;

    let navbar = document.querySelector('.right-nav-bar');
    const langDirection = getCurrentLangDirection();
    let styleProp = langDirection === 'ltr' ? 'right' : 'left';

    if (isDesktop){
        styleProp = 'right';
        const backBtn = document.querySelector('.menu__back-btn');

        gsap.to(backBtn,{[styleProp]: -500, opacity: 0, duration: .45,
            onStart:()=>{

            },
            onComplete:()=>{
                backBtn.classList.add('prevent-hide');
            }});

        gsap.to(navbar,{[styleProp]: -200, opacity: 0, duration: .2,
            onStart:()=>{
                navbar.classList.remove('showed');
            },
            onComplete:()=>{
                navbar.classList.add('hide');
            }});


    } else {

        gsap.to(navbar,{[styleProp]: -200, opacity: 0, duration: 1,
            onStart:()=>{
                navbar.style.removeProperty('left');
                navbar.style.removeProperty('right');
                navbar.classList.remove('showed');
            },
            onComplete:()=>{
                navbar.classList.add('hide');
            }});
    }
}
